import React from "react";
import { useSelector } from "react-redux";
import moment from 'moment';
import 'moment-timezone';

const Date = ({ date = null }) => {
    const profile = useSelector(state => state.profile);
    const userTimeZone = profile?.profile?.time_zone;

    if (date && typeof date === "object" && date.$date?.$numberLong) {
        const timestamp = parseInt(date.$date.$numberLong, 10);
        
        // Convert MongoDB/BSON timestamp using target timezone if present
        return userTimeZone && userTimeZone !== ''
            ? moment(timestamp).tz(userTimeZone).format('YYYY-MM-DD HH:mm:ss')
            : moment(timestamp).format('YYYY-MM-DD HH:mm:ss');

    } else if (typeof date === "string" && date.trim() !== "") {
        
        // ─── PARSE AS UTC FIRST THEN SHIFT TO USER TIMEZONE ───
        if (userTimeZone && userTimeZone !== '') {
            return moment.utc(date).tz(userTimeZone).format('YYYY-MM-DD HH:mm:ss');
        } else {
            return moment(date).format('YYYY-MM-DD HH:mm:ss');
        }

    } else {
        return date;
    }
};

export default Date;